<template>
  <DialogConfirmation ref="dialogConfirmation"/>
  <div class="row">
    <div class="col">
      <DataTable
          class="p-datatable-sm"
          :value="groupesSecurites"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          selectionMode="single"
          dataKey="cle"
          @row-select="onRowSelect"
          :paginator="true"
          :rows="10"
          sort-field="cle"
          :sortOrder="-1"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30, 100]"
          currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} groupes de sécurité"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column
            field="cle"
            header="Clé"
            :sortable="true"
        ></Column>
        <Column
            field="nom"
            header="Nom"
            :sortable="true"
        >
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column
            field="confidentialite"
            header="Confidentialité"
            :sortable="true"
        >
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <Dropdown class="dropdown-height"
                          v-model="data[field]"
                          :options="confidentialiteLibelles"
                          optionValue="valeur"
                          optionLabel="texte"
                          scrollHeight="205px"
                          :showClear="true"/>
              </div>
            </div>
          </template>
        </Column>
        <Column
            field="autorite"
            header="Autorité"
            :sortable="true"
        >
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <Dropdown class="dropdown-height"
                          v-model="data[field]"
                          :options="niveauHierarchiqueLibelles"
                          optionValue="valeur"
                          optionLabel="texte"
                          scrollHeight="205px"
                          :showClear="true"/>
              </div>
            </div>
          </template>
        </Column>
        <Column
            field="abreviation"
            header="Abréviation"
            :sortable="true"
        >
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column
            field="description"
            header="Description"
            :sortable="true"
        >
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column headerStyle="width: 8rem" :exportable="false">
          <template #body="slotProps">
            <div class="row">
              <div class="col">
                <Button
                    icon="pi pi-save"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="sauvegarder(slotProps.data)"
                />
              </div>
              <div class="col">
                <Button
                    icon="pi pi-trash"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="confirmerSuppression(slotProps.data)"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>

import DialogConfirmation from '../../Commun/DialogConfirmation.vue';

export default {
  props: ['groupesSecurites', 'confidentialiteLibelles', 'niveauHierarchiqueLibelles', 'isRechercheDataLoading'],
  emits: ['removeGroupeSecuriteFromList'],
  components: {
    DialogConfirmation
  },
  data() {
    return {
      groupeSecuriteToDelete: null,
    }
  },
  methods: {
    confirmerSuppression(data) {
      this.groupeSecuriteToDelete = data
      this.$confirm.require({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: "Voulez-vous supprimer ce groupe de sécurité?",
        accept: this.supprimer,
        reject: () => {},
      })
    },
    supprimer() {
      this.$store.dispatch('pilotage/supprimerGroupesSecuriteAction', {groupeSecurite: this.groupeSecuriteToDelete})
          .then((res) => {
            if (res?.data?.messageVOs.length == 0) {
              this.$toast.add({
                severity: 'success',
                summary: 'Suppression du groupe de sécurité',
                detail: "La suppression a été effectuée",
                life: 6000
              });
              this.$emit("removeGroupeSecuriteFromList", this.groupeSecuriteToDelete.cle);
            } else {
              this.$root.$refs.messagesComp.messagesList = res.data.messageVOs;
            }
          });
    },
    sauvegarder(data) {
      this.$store.dispatch('pilotage/modifierGroupesSecuriteAction', {groupeSecurite: data}).then(() => {
        this.$toast.add({
          severity:'success',
          summary: 'Modifier Groupe Sécurité',
          detail:"La modification a été effectué",
          life: 6000
        });
      });
    },
    onRowSelect(event) {
      this.$router.push({
        name: "consulterGroupesSecurite",
        params: {cle: event.data.cle},
      });
    },
  }
}
</script>
